import { useContactMutation } from "@src/data/mutations/contact";
import { useEffect } from "react";
import { toast } from "react-toastify";

import { LoginButton } from "@src/components/LoginButton";

import "./style.less";

function getInput(id: string) {
  return document.getElementById(id) as HTMLInputElement;
}

// https://fabricca.pro/delete-account (exigência da Google)
export function DeleteAccount() {
  const contact = useContactMutation();

  useEffect(() => {
    document.body.classList.add("DeleteAccount-body");
    return () => {
      document.body.classList.remove("DeleteAccount-body");
    };
  }, []);

  return (
    <div className="DeleteAccount-page">
      <LoginButton />
      <title>Solicitação de Exclusão de Conta - FabriccaPro</title>

      <h1>Solicitação de Exclusão de Conta</h1>
      <p>
        Use este formulário para solicitar a remoção da conta e dos dados
        associados ao aplicativo <strong>FabriccaPro</strong>.
      </p>

      <div className="alert">
        <strong>Atenção:</strong> O FabriccaPro é um serviço corporativo. A
        exclusão da conta técnica resultará na interrupção do serviço de
        sonorização no estabelecimento e pode implicar no cancelamento do
        contrato vigente.
      </div>

      <form
        onSubmit={(event) => {
          event.preventDefault();
          const company_name = getInput("company_name");
          const cnpj = getInput("cnpj");
          const email = getInput("email");
          contact
            .mutateAsync({
              name: company_name.value,
              email: email.value,
              phone: "n/a",
              message: `Solicitação de Exclusão de Conta\nCNPJ ${cnpj.value}`,
            })
            .then(
              () => {
                company_name.value = "";
                cnpj.value = "";
                email.value = "";
                toast.success(
                  "Formulário enviado com sucesso. Aguarde nosso retorno.",
                );
              },
              (error) => {
                console.log("Falha ao submeter formulário:", error);
                toast.error(error.message);
              },
            );
        }}
      >
        <label htmlFor="company_name">Nome da Empresa / Razão Social</label>
        <input
          type="text"
          id="company_name"
          name="company_name"
          required
          placeholder="Ex: Farmácia Exemplo Ltda"
        />

        <label htmlFor="cnpj">CNPJ (para identificação do contrato)</label>
        <input
          type="text"
          id="cnpj"
          name="cnpj"
          required
          placeholder="00.000.000/0000-00"
        />

        <label htmlFor="email">E-mail de Contato</label>
        <input
          type="email"
          id="email"
          name="email"
          required
          placeholder="email@empresa.com.br"
        />

        <button type="submit">Solicitar Exclusão</button>
      </form>

      <div className="data-policy">
        <h2>Política de Retenção e Exclusão de Dados</h2>
        <p>Ao solicitar a exclusão, o processo seguirá as etapas abaixo:</p>

        <p>
          <strong>1. Dados Excluídos Imediatamente:</strong>
          <br />
          Após a validação da solicitação e encerramento do contrato,
          removeremos as credenciais de acesso (login e senha), tokens de
          autenticação de dispositivos e associações de players ativos.
        </p>

        <p>
          <strong>2. Dados Mantidos (Retenção Legal):</strong>
          <br />
          Alguns dados não podem ser apagados imediatamente devido a obrigações
          legais e fiscais:
        </p>
        <ul>
          {/* <li>
            <strong>Logs de Execução Musical:</strong> Mantidos por até 5 anos
            para fins de auditoria do ECAD e comprovação de execução de direitos
            autorais.
          </li> */}
          <li>
            <strong>Dados de Faturamento:</strong> Histórico de notas fiscais e
            contratos mantidos conforme legislação tributária vigente.
          </li>
        </ul>
      </div>

      <div className="footer">
        &copy; 2026 Fabricca Multimídia. Todos os direitos reservados.
      </div>
    </div>
  );
}
